import toast from "react-hot-toast";
import { subscriptionService } from "../services";


export const createSubscription = async (data:{plan: string}) => {
    try {  
        const res = await subscriptionService.post("/subscriptions", data)
        return res.data
    } catch (error: any) {
        toast.error(error?.message)
    }
}

export const processSubscription = async (id:number) => {
   try {
    const res = await subscriptionService.patch(`/subscriptions/${id}/process`)
    return res.data
   } catch (error:any) {
    toast.error(error?.message)
   }
}

export const cancelSubscription = async () => {
    try {
        const res = await subscriptionService.patch("/subscriptions/cancel")
        return res.data
    } catch (error:any) {
        toast.error(error?.message)
    }
}

export const getActiveSubscription = async () => {
    try {
        const res = await subscriptionService.get("/subscriptions/active")
        return res.data
    } catch (error:any) {
        toast.error(error?.message)
    }
}   

export const getSpecificSubscription = async (id: number) => {
    try {
        const res = await subscriptionService.get(`/subscriptions/${id}`)
        return res.data
    } catch (error:any) {
    toast.error(error?.message || error?.response?.data)
    }
}

export const getSubscriptionHistory = async () => {
    try {
        const res = await subscriptionService.get("/subscriptions/history")
        return res.data
    } catch (error:any) {
        toast.error(error?.message)
    }
}